
<div class=" d-none d-sm-block">
	<!------------------------------------------TITLE----------------------------------------------->
	<div class="title-box uk-border-rounded p-1 d-none d-sm-block">
		<div class="head-card p-1 inner-title-box">
		  <h1 class="title-text text-center font-weight-bold">
			MULTI BRAND WATER CHILLER
		  </h1>
		  <div class="text-right">
			<h5 class="text-light">
				<span class="sub-menu" routerLink="/home-page">HOME </span>&nbsp;
				<span class="sub-menu" routerLink="/contact-us"> CONTACT</span>&nbsp;
				<span class="sub-menu" routerLink="/ourproducts"> PRODUCTS</span>&nbsp;
				<span class="sub-menu" routerLink="/verticals"> SERVICES</span>&nbsp;
			</h5>
		  </div>
		</div>
	   </div>

	  <!--------------------------------------------------TITLE END-------------------------------------------->
	<!------------------------------------------------------------CAROSUEL----------------------------------------------------->
	<div class="content-container">   
		<a class="mail-call" href="tel:8489359948">
            <span class="fa fa-phone" aria-hidden="true"></span>
        </a>  
		<a class="mail-call1" href="mailto:rvproduction2017@gmail.com"><span class="fa fa-envelope"></span>
		</a>   
		<a class="mail-call2" href="https://wa.me/8489359948" target="_blank">
			<span class="fa fa-whatsapp"></span>
		</a>
        <img src="../../../assets/img/multi-brand/water-chillers-multi-brand.jpeg" alt="">
        <br>
        <ul>
            <li>Air-Cooled Water Chillers – Uses air to dissipate heat and are typically installed in locations with adequate ventilation..</li>
            <li>Water-Cooled Water Chillers – Utilizes water (usually from a cooling tower) to remove heat and 
                is ideal for environments where air cooling is not efficient.</li>
            <li>&nbsp; Industrial Water Chillers – Heavy-duty chillers used in industrial applications like plastics manufacturing,
                 food processing, and pharmaceuticals.</li>
            <li> Portable Water Chillers – Smaller, transportable units for temporary or small-scale cooling needs.</li>
        </ul>



        <p>
            Regular maintenance keeps your water chiller running at optimal efficiency, reduces energy consumption, and prolongs the life of
             your system. Neglecting maintenance can lead to breakdowns, reduced cooling capacity, and higher operational costs.
        </p>
        <p>
            Maximized energy efficiency, lowering your overall operating costs.
            Prevention of system malfunctions that can lead to costly repairs.
            Ensures reliable cooling performance in critical systems and environments.
        </p>
    </div>
</div>




<!--------------------------------------- MOBILE VIEW ------------------------------------------------->

<div class=" d-block d-sm-none">
	<a class="mail-call" href="tel:8489359948">
		<span class="fa fa-phone" aria-hidden="true"></span>
	</a>  
	<a class="mail-call1" href="mailto:rvproduction2017@gmail.com"><span class="fa fa-envelope"></span>
	</a>   
	<a class="mail-call2" href="https://wa.me/8489359948" target="_blank">
		<span class="fa fa-whatsapp"></span>
	</a>
    <img src="../../assets/img/multi-brand/multibrand4.webp" alt="">
    <br>
    <ul>
        <li>Air-Cooled Water Chillers – Uses air to dissipate heat and are typically installed in locations with adequate ventilation..</li>
        <li>Water-Cooled Water Chillers – Utilizes water (usually from a cooling tower) to remove heat and 
            is ideal for environments where air cooling is not efficient.</li>
        <li>&nbsp; Industrial Water Chillers – Heavy-duty chillers used in industrial applications like plastics manufacturing,
             food processing, and pharmaceuticals.</li>
        <li> Portable Water Chillers – Smaller, transportable units for temporary or small-scale cooling needs.</li>
    </ul>



    <p>
        Regular maintenance keeps your water chiller running at optimal efficiency, reduces energy consumption, and prolongs the life of
         your system. Neglecting maintenance can lead to breakdowns, reduced cooling capacity, and higher operational costs.
    </p>
    <p>
        Maximized energy efficiency, lowering your overall operating costs.
        Prevention of system malfunctions that can lead to costly repairs.
        Ensures reliable cooling performance in critical systems and environments.
    </p>
    </div>
